<template>
  <div class="normal-render" >
    <normalText v-if="answers.useNormalText" :answers="answers" />
    <zhenxuanguBox v-else :answers="answers" :session="session" />
    <GuideQuestion :session="session" v-if="needGuide && showGuide">
    </GuideQuestion>
  </div>
</template>
<script>
import zhenxuanguBox from "./zhenxuanguBox";
import normalText from "./normalText";
import GuideQuestion from "@/components/guide-question/GuideQuestion";
export default {
  name: "normalRender",
  components: {
    zhenxuanguBox,
    GuideQuestion,
    normalText,
  },
  props: {
    answers: {
      type: Array | Object,
      default: () => [],
    },
    session: Object,
    needGuide: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    showGuide() {
      return (
        this.session.response &&
        this.session.response.answer &&
        this.session.response.answer[0] &&
        this.session.response.answer[0].sugArr &&
        this.session.response.answer[0].sugArr[0]
      );
    },
  },
};
</script>
<style lang="less" scoped>
.normal-render {
  background-color: #fff;
  padding: 15px 0.48rem;
  border-radius: 2px 12px 12px 12px;
  position: relative;
  box-sizing: border-box;
  line-height: 25px;
 
}
</style>
